import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify)
import pt from 'vuetify/src/locale/pt.ts';

export default new Vuetify({
  lang: {
    current:  'pt',
    locales: { pt }
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#01579b",
        secondary: "#e8ecfa",
        accent: "#448aff",
        error: "#d32f2f",
        info: "#1e88e5",
        success: "#06803c",
        warning: "#ffb300"
      }
    }
  }
});
